import Configuration from "../../components/Configuration"

import { routeTypes } from "../../../../hooks/useSystemRoutes"

export default function ConfigurationPage() {

    return (
        <Configuration 
            routeType={routeTypes.admin}
        />
    )
}